import React from 'react'
import PropTypes from 'prop-types'
import classNames from 'classnames'
import checkImg from './check.svg'
import styles from './chip.scss'

export const TYPES = ['primary', 'secondary', 'tertiary']

export const COLORS = ['red', 'green']

const Chip = (props) => {
  const { type, label, color, check } = props

  const chipClass = classNames(styles.chip, {
    [styles[type]]: type,
    [styles[color]]: color
  })

  return (
    <div className={chipClass}>
      {check && <img src={checkImg} alt={label} />}

      {label}
    </div>
  )
}

Chip.defaultProps = {
  type: null,
  label: '',
  color: null,
  check: false
}

const { bool, oneOf, string } = PropTypes

Chip.propTypes = {
  type: oneOf(TYPES),
  label: string,
  color: oneOf(COLORS),
  check: bool
}

export default Chip
